import io from 'socket.io-client'
import { urlSocket } from './api/url'

const socket = io.connect(`${urlSocket}`, {
    reconnection: true, // whether to reconnect automatically
    reconnectionAttempts: Infinity, // number of reconnection attempts before giving up
    // Exponential backoff with jitter: at 10 ms, 1 000 open pages retried a stalled or restarting backend
    // ~100 000 times per second (6 Oct 2026), which kept it down longer and crowded out real requests.
    reconnectionDelay: 1000, // how long to initially wait before attempting a new reconnection
    reconnectionDelayMax: 30000, // maximum amount of time to wait between reconnection attempts. Each attempt increases the reconnection delay by 2x along with a randomization factor
    randomizationFactor: 0.5,
    transports: ['websocket'],
    upgrade: false,
    'force new connection': true,
})

export { socket }
